import { render, staticRenderFns } from "./IceMapSub.vue?vue&type=template&id=27990d0b"
import script from "./IceMapSub.vue?vue&type=script&lang=js"
export * from "./IceMapSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports